import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Logo } from "./components/ui";
import { api, onSessionChange, queryClient } from "./lib/api";
import { makeRouter } from "./router";
import "./styles.css";

const router = makeRouter({ api, queryClient });

// Se a sessão terminar (logout, bloqueio, refresh recusado), as rotas
// reavaliam as permissões e quem não está mais logado vai para /entrar.
onSessionChange(() => void router.invalidate());

const root = createRoot(document.getElementById("root")!);

root.render(
  <div className="flex min-h-dvh items-center justify-center">
    <Logo className="animate-pulse text-2xl" />
  </div>,
);

// Recupera a sessão pelo cookie antes de decidir qual página mostrar.
void api.restore().finally(() => {
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>,
  );
});
